import { errorMessage } from "helpers/utils";
import { call, put, select, takeEvery } from "redux-saga/effects";
import CustomerService from "services/CustomerService";
import {
  CREATE_ACCOUNT_BANK,
  CREATE_CUSTOMER_INVOICE,
  DELETE_CUSTOMER_INVOICE,
  EDIT_CUSTOMER_INVOICE,
  GET_ALL_ACCOUNT_BANK,
  GET_ALL_CUSTOMER_INVOICE,
  GET_DETAIL_CUSTOMER_INVOICE,
  GET_LIST_CUSTOMER_INVOICE,
} from "./actionTypes";
import {
  createAccountBankFail,
  createAccountBankSuccess,
  createCustomerInvoiceFail,
  createCustomerInvoiceSuccess,
  deleteCustomerInvoiceFail,
  deleteCustomerInvoiceSuccess,
  editCustomerInvoiceFail,
  editCustomerInvoiceSuccess,
  getAllAccountBankFail,
  getAllAccountBankSuccess,
  getAllCustomerInvoiceFail,
  getAllCustomerInvoiceSuccess,
  getDetailCustomerInvoiceFail,
  getDetailCustomerInvoiceSuccess,
  getListCustomerInvoiceFail,
  getListCustomerInvoiceSuccess,
} from "./actions";

function* fetchGetCustomerInvoice({ params }) {
  try {
    const perPage = params.sizePerPage;
    const page = params.page;
    const columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    // Call api
    const response = yield call(
      CustomerService.listCustomer,
      page,
      perPage,
      columnFilter,
      keywords,
      sort
    );
    const totalCount = response._meta.totalCount;
    yield put(getListCustomerInvoiceSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getListCustomerInvoiceFail(errorMessage(error)));
  }
}

function* fetchGetDetailCustomerInvoice({ id }) {
  try {
    const response = yield call(CustomerService.detailCustomer, id);
    // console.log("response", response);
    yield put(getDetailCustomerInvoiceSuccess(response));
  } catch (error) {
    yield put(getDetailCustomerInvoiceFail(errorMessage(error)));
  }
}

function* fetchCreateCustomerInvoice({ data }) {
  try {
    const response = yield call(CustomerService.createCustomer, data);
    yield put(createCustomerInvoiceSuccess(response));
  } catch (error) {
    yield put(createCustomerInvoiceFail(errorMessage(error)));
  }
}

function* fetchCreateAccountBank({ data }) {
  try {
    let { buStoreHeader } = yield select(state => state.Dashboard);
    const response = yield call(
      CustomerService.createAccountBank,
      data,
      buStoreHeader
    );
    yield put(createAccountBankSuccess(response));
  } catch (error) {
    yield put(createAccountBankFail(errorMessage(error)));
  }
}

function* fetchEditCustomerInvoice({ data, id }) {
  try {
    const response = yield call(CustomerService.editCustomer, data, id);
    yield put(editCustomerInvoiceSuccess(response));
  } catch (error) {
    yield put(editCustomerInvoiceFail(errorMessage(error)));
  }
}

function* fetchDeleteCustomerInvoice({ id }) {
  try {
    const response = yield call(CustomerService.deleteCustomer, id);
    // Wait XML generate
    yield put(deleteCustomerInvoiceSuccess(response));
  } catch (error) {
    yield put(deleteCustomerInvoiceFail(errorMessage(error)));
  }
}

function* fetchGetAllCustomer({ type_id }) {
  try {
    const response = yield call(CustomerService.listAllCustomer, type_id);
    const list = response.items.map(item => {
      return {
        ...item,
        value: item.ma,
        label: item.ma,
      };
    });
    yield put(getAllCustomerInvoiceSuccess(list));
  } catch (error) {
    yield put(getAllCustomerInvoiceFail(errorMessage(error)));
  }
}

function* fetchGetAllAccountBank({}) {
  try {
    let { buStoreHeader } = yield select(state => state.Dashboard);
    const response = yield call(
      CustomerService.listAllAccountBank,
      buStoreHeader
    );
    const list = response.items.map(item => {
      return {
        ...item,
        value: item.account_number,
        label: item.account_number + " - " + item.bank_name,
      };
    });
    yield put(getAllAccountBankSuccess(list));
  } catch (error) {
    yield put(getAllAccountBankFail(errorMessage(error)));
  }
}

function* customerInvoiceSaga() {
  yield takeEvery(GET_LIST_CUSTOMER_INVOICE, fetchGetCustomerInvoice);
  yield takeEvery(GET_DETAIL_CUSTOMER_INVOICE, fetchGetDetailCustomerInvoice);
  yield takeEvery(CREATE_CUSTOMER_INVOICE, fetchCreateCustomerInvoice);
  yield takeEvery(EDIT_CUSTOMER_INVOICE, fetchEditCustomerInvoice);
  yield takeEvery(DELETE_CUSTOMER_INVOICE, fetchDeleteCustomerInvoice);
  yield takeEvery(CREATE_ACCOUNT_BANK, fetchCreateAccountBank);

  yield takeEvery(GET_ALL_CUSTOMER_INVOICE, fetchGetAllCustomer);
  yield takeEvery(GET_ALL_ACCOUNT_BANK, fetchGetAllAccountBank);
}

export default customerInvoiceSaga;
